import { type AxiosError, isAxiosError } from "axios";

const DEACTIVATED_ADMIN_USER_ERROR = "admin_user_deactivated";

export const isDeactivatedAdminUserError = (
  error: unknown,
): error is AxiosError<{ value: string }> => {
  return (
    isAxiosError(error) &&
    error.response?.status === 401 &&
    error.response.data.error === DEACTIVATED_ADMIN_USER_ERROR
  );
};
